
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","fill":"#838383"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0h3.273v1.09h17.454V0H24v3.273h-1.09v17.454H24V24h-3.273v-1.09H3.273V24H0v-3.273h1.09V3.273H0V0zm3.273 21.91v-1.183H2.09V3.273h1.182V2.09h17.454v1.182h1.182v17.454h-1.182v1.182H3.273z","fill":"#838383"}})])
          )
        }
      }
    